import React, { useState } from "react";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import PropTypes from 'prop-types';

const CpfCnpjMask = React.forwardRef(function CpfCnpjMask(props, ref) {
  const { inputRef, onChange, value, ...other } = props;
  const [cpfCnpj, setCpfCnpj] = useState("");
  return (
    <CpfCnpj
      
      value={cpfCnpj}
      onChange={(event) => {
        setCpfCnpj(event.target.value);
      }}
      {...other}
    />
  );
});

CpfCnpjMask.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};


export default CpfCnpjMask;
